import React from "react";
import Flatpickr from "react-flatpickr";
import "flatpickr/dist/themes/material_blue.css";

const DatePicker = ({
  name,
  label,
  placeholder,
  options,
  value,
  onChange,
  style,
}) => {
  return (
    <>
      {value && (
        <Flatpickr
          value={new Date(value)}
          options={{ dateFormat: "d-m-Y", ...options }}
          onChange={(selectedDates) => {
            const date = selectedDates[0];
            const formattedDate = `${date.getFullYear()}-${String(
              date.getMonth() + 1,
            ).padStart(2, "0")}-${String(date.getDate()).padStart(2, "0")}`;
            onChange(formattedDate);
          }}
          placeholder={placeholder || "Select Date"}
          className="flatpickr-input form-control commonInput"
          style={style}
          // style={{
          //   padding: "8px",
          //   fontSize: "16px",
          //   border: "1px solid #1976d2",
          //   borderRadius: "4px",
          //   width: "100%",
          //   color: "#1976d2",
          // }}
        />
      )}
    </>
  );
};

export default DatePicker;
